import { apiCall, apiCallPublic, baseUrl } from './config';
import { shouldUseMock } from '../../utils/common';
import {
  SupportMailGetMock,
  getFaqMock,
  getLogoMock,
  getProviderSSOList,
  getVocabularyMock,
  successMock,
} from './mock';
import {
  authPath,
  faqPath,
  homePath,
  platformPath,
  trackingPath,
} from '../../utils/paths';

export default {
  getFaq: (isLogged) => {
    if (shouldUseMock()) {
      return getFaqMock();
    }
    if (isLogged) {
      return apiCall(`${baseUrl}${faqPath}faq/list`, 'GET');
    }
    return apiCallPublic(`${baseUrl}${faqPath}faq/list`, 'GET');
  },
  getLogo: () => {
    if (shouldUseMock()) {
      return getLogoMock();
    }
    return apiCallPublic(`${baseUrl}${homePath}public/info`, 'GET');
  },
  getVocabulary: () => {
    if (shouldUseMock()) {
      return getVocabularyMock();
    }
    return apiCallPublic(`${baseUrl}${platformPath}vocabulary/list`, 'GET');
  },
  ssoProviderListGet: () => {
    if (shouldUseMock()) {
      return getProviderSSOList();
    }
    return apiCallPublic(`${baseUrl}${authPath}saml/sso/provider/list`, 'GET');
  },
  supportMailGet: () => {
    if (shouldUseMock()) {
      return SupportMailGetMock();
    }
    return apiCall(`${baseUrl}${homePath}help_desk`, 'GET');
  },
  actionTracking: (action_type, action) => {
    if (shouldUseMock()) {
      return successMock();
    }
    return apiCall(
      `${baseUrl}${trackingPath}${action_type}/${action}/track`,
      'POST',
      {}
    );
  },
};
